export enum RequestStatus {
    aborted = 'aborted',
    accepted = 'accepted',
    active = 'active',
    cancelled = 'cancelled',
    completed = 'completed',
    draft = 'draft',
    rejected = 'rejected',
    rejectedAndArchived = 'rejectedAndArchived',
    rejectedAndResent = 'rejectedAndResent',
    requested = 'requested',
    suspended = 'suspended',
}
